<template>
  <div class="pageFooter">
    <a id="IntegrateWUs"></a>
    <h1>Feedback</h1>
    <h2>Follow the link below to leave feedback on your MAF experience! Doing so will help us help you with Making Authentic Friendships. Have questions about the app? <a href="./MAF-FAQs.pdf" target="_blank" style="color: white">Visit our FAQs.</a></h2>
    <a href="https://www.surveymonkey.com/r/LLQ7WT8" target="_blank" class="submitLink">Submit Feedback</a>
    <img id="whiteBar" src='./assets/line_white.png'/>
    <div class="footerLinks">
      <img id="footerLogo" src="./assets/logo_footer.png" />
      <div class="navigation">
        <a v-scroll-to="'#AboutUs'"><button  class="tablinks">ABOUT US</button></a>
        <!--<a v-scroll-to="'#Media'"><button class="tablinks" >MEDIA</button></a>-->
        <a v-scroll-to="'#TheApp'" ><button class="tablinks" >THE APP</button></a>
        <a v-scroll-to="'#IntegrateWUs'"><button class="tablinks" >FEEDBACK</button></a>
        <a href="https://making-authentic-friendships.myshopify.com/" target="_blank"><button class="tablinks" >MERCH</button></a>
        <a href="./MAFBeSmart.BeSafe.pdf" target="_blank"><button class="tablinks" >SAFETY</button></a>
        <a href="./MAF-FAQs.pdf" target="_blank"><button class="tablinks" >FAQS</button></a>
        <a href="https://portal.makingauthenticfriendships.com/signup" target="_blank"><button class="tablinks">SIGN UP</button></a>
        <a href="https://portal.makingauthenticfriendships.com/signin" target="_blank"><button class="tablinks">SIGN IN</button></a>
      </div>
      <div class="socialMedia">
        <a class="socialMediaLink" href="https://www.youtube.com/watch?v=sFnd1d_Y8BY" target="_blank"><img src="./assets/icon_yt.png"/></a>
        <a class="socialMediaLink" href="https://www.facebook.com/Makingauthenticfriendships/" target="_blank"><img src="./assets/icon_fb.png"/></a>
        <a class="socialMediaLink" href="https://www.instagram.com/makingauthenticfriendships/" target="_blank"> <img src="./assets/icon_ig.png"/></a>
        <a class="socialMediaLink" href="https://www.linkedin.com/in/juliana-fetherman-676467157/" target="_blank"><img src="./assets/icon_li.png"/></a>
      </div>
    </div>
    <p class="credits maf-profit">Making Authentic Friendships, LLC is a for-profit organization.</p>
    <p class="credits maf-profit"><a href="/MAF_Privacy_Policy.pdf" target="_blank">Privacy Policy</a></p>
    <p class="credits">Developed by <a href="http://www.seisan.com/" target="_blank">Seisan Consulting, LLC.</a></p>
    <p id="copyright" ><br/>&copy; 2020 Making Authentic Friendships </p>
  </div>
</template>
<script>

export default {
  name: 'pageFooter',
  components: {}
}

</script>

<style scoped>
.pageFooter {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-image: url("./assets/bg_footer.jpg");
  text-align: center;
  padding-bottom: 0;
}

#whiteBar {
  margin: 3rem 0;
}

h1 {
  padding-top: 3rem;
  margin-bottom: 0 !important;
  color:white;
  font-size: 60px;
  font-family: 'chunk';
  font-weight: inherit;
}

h2 {
  width: 60%;
  color:white;
  font-size: 25px;
  font-family: 'futura';
  font-weight: inherit;
  letter-spacing: 2px;
  font-weight: bold; 
  padding-bottom: 2rem;
}

.footerLinks {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2rem;
}

.submitLink {
  color: white;
  font-family:'chunk';
  font-weight: 100;
  text-decoration: none;
  font-size: 25px;
  background-color: rgba(0, 0, 0, 0.325);
  padding: 1rem;
  border-radius: 25px;
}

.tablinks {
  background-color: transparent;
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
  margin: 1vw 1vw;
  cursor: pointer;
  outline: none;
  font-family:'chunk';
}

.socialMediaLink img {
  background: none;
  border: none;
  outline: none;
  margin-left: 20px;
  width: 40px;
}

.firstLink {
  margin: 0;
}
.maf-profit{
  margin-bottom:0;
}
.credits {
  color: white !important;
}

.credits a {
  color: white !important;
}

.credits a {
  text-decoration: none;
}

.credits a:visited {
  color: white !important;
}

.credits a:hover {
  text-decoration: underline;
}

#copyright {
  background:rgba(63, 63, 63, 0.325);
  font-size: 16px;
  font-weight: normal;
  color:white;
  text-transform: uppercase;
  padding-top: 2vw;
  padding-bottom: 2vw;
  margin-bottom: 0;
  font-family: 'futura';
  width: 100%;
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 767px){
  .tablinks {
    font-size: 15px;
  }
  .socialMedia {
    width:100%;
    align-self: center;
    align-items: center;
  }
  .firstLink {
    margin-left:0 !important;
  }
  .socialMediaLink img {
    margin-left:15px;
    width:30px;
  }
  .submitLink {
    font-size: 18px;
  }
  #footerLogo {
    padding-bottom: 1rem;
  }
}
@media screen and (max-width:1023px) {
  h1 {
    font-size:30px; 
  }
  h2 {
    font-size:16px;
    width:80%;
    margin-left:10%;
    letter-spacing: 0;
  }
}
</style>